// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox {
  position: relative;
  width: 15px;
  height: 15px;
  z-index: 1;
  cursor: pointer;
}
.checkbox input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  opacity: 0;
}
.checkbox input:checked ~ svg {
  opacity: 1;
}
.checkbox label {
  position: absolute;
  z-index: 1;
  cursor: pointer;
  display: flex;
  width: 100%;
  height: 100%;
}
.checkbox label svg {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 8px;
  z-index: 3;
  fill: #fff;
  opacity: 0;
  transition: all 0.3s ease;
}
.checkbox label:before {
  position: absolute;
  left: 0;
  top: 0px;
  font-family: "FontAwesome";
  content: "";
  display: block;
  width: 13px;
  height: 13px;
  border: 1px #dedede solid;
  background-color: transparent;
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.3s ease;
}
.checkbox label:hover svg {
  fill: #03a9f4;
}
.checkbox label:hover:before {
  border-color: #03a9f4;
}
.checkbox.disabled {
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/Checkbox/Checkbox.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAAF;AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;AACJ;AACM;EACE,UAAA;AACR;AAGE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AADJ;AAGI;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;AADN;AAGI;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,0BAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AADN;AAIM;EACE,aAAA;AAFR;AAIM;EACE,qBAAA;AAFR;AAME;EACE,YAAA;AAJJ","sourcesContent":["@import '../../../styles/_variables';\r\n.checkbox{\r\n  position: relative;\r\n  width: 15px;\r\n  height: 15px;\r\n  z-index: 1;\r\n  cursor: pointer;\r\n  input{\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    top:0;\r\n    left: 0;\r\n    z-index: 10;\r\n    opacity: 0;\r\n    &:checked ~{\r\n      svg{\r\n        opacity:1;\r\n      }\r\n    }\r\n  }\r\n  label{\r\n    position: absolute;\r\n    z-index: 1;\r\n    cursor: pointer;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n   // background:#fff;\r\n    svg{\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      right:0;\r\n      bottom: 0;\r\n      margin: auto;\r\n      width: 8px;\r\n      z-index: 3;\r\n      fill:#fff;\r\n      opacity: 0;\r\n      transition: all 0.3s ease;\r\n    }\r\n    &:before {\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0px;\r\n      font-family: 'FontAwesome';\r\n      content: \"\";\r\n      display: block;\r\n      width: 13px;\r\n      height: 13px;\r\n      border: 1px #dedede solid;\r\n      background-color: transparent;\r\n      border-radius: 4px;\r\n      overflow: hidden;\r\n      transition: all 0.3s ease;\r\n    }\r\n    &:hover{\r\n      svg{\r\n        fill: #03a9f4\r\n      }\r\n      &:before {\r\n        border-color: #03a9f4\r\n      }\r\n    }\r\n  }\r\n  &.disabled{\r\n    opacity: 0.8;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
